import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'
import { HeroTitleTypography } from 'src/components/layouts/HeroRebrand/HeroTitleTypography'
import { WidgetSectionRebrandResult } from 'src/components/layouts/Page/SanityContentPage/types'
import { DonateWidget } from 'src/components/organisms/DonateWidget'

import colors from 'src/styles/theme/colors'

type WidgetType = WidgetSectionRebrandResult['widget']
type WidgetBgColor = WidgetSectionRebrandResult['color'] | 'white'

const contrastColor = (color: WidgetBgColor): WidgetBgColor => {
  switch (color) {
    case 'espresso':
    case 'forestDeep':
    case 'wineRich':
      return 'white'
    default:
      return 'forestDeep'
  }
}

type WidgetSectionRebrandProps = {
  heading: string
  eyebrow?: string
  intro?: string
  widget: WidgetType
  color?: WidgetBgColor
}

const widgetTypeMap: Record<WidgetType, React.ReactNode> = {
  donateWidget: <DonateWidget />
}

export const WidgetSectionRebrand = ({
  heading,
  eyebrow,
  intro,
  widget,
  color
}: WidgetSectionRebrandProps) => {
  const widgetElement = widget ? widgetTypeMap[widget] : null
  return (
    <section
      className='w-full'
      style={{
        ...(color && {
          backgroundColor: colors[color],
          color: contrastColor(color)
        })
      }}
    >
      <div className='flex-1 flex flex-col md:flex-row w-full items-center lg:items-baseline mx-auto px-4 py-12 lg:px-20 lg:py-18'>
        <div className='flex-1 flex flex-col w-full items-center lg:items-baseline'>
          {eyebrow ? (
            <TypographyRebrand variant='eyebrow'>{eyebrow}</TypographyRebrand>
          ) : null}
          <HeroTitleTypography title={heading} variant='h1' />
          {intro ? (
            <TypographyRebrand variant='introduction'>
              {intro}
            </TypographyRebrand>
          ) : null}
        </div>
        <div className='flex flex-1 relative'>{widgetElement}</div>
      </div>
    </section>
  )
}

export default WidgetSectionRebrand
